import { render, staticRenderFns } from "./oc-footer-container.vue?vue&type=template&id=79144215&scoped=true"
import script from "./oc-footer-container.vue?vue&type=script&lang=js"
export * from "./oc-footer-container.vue?vue&type=script&lang=js"
import style0 from "./oc-footer-container.vue?vue&type=style&index=0&id=79144215&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79144215",
  null
  
)

export default component.exports